'use client';
import React from 'react';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

const services = [
  {
    icon: 'fas fa-chess-knight',
    title: 'Estratégia e Planejamento',
    desc: 'A base de tudo. Estruturamos o caminho antes da execução para que cada ação tenha direção e propósito.',
    items: [
      'Planejamento estratégico de marketing',
      'Posicionamento de marca',
      'Persona e público-alvo',
      'Jornada do cliente e funil de vendas',
      'Go-to-market',
      'Análise de concorrência e mercado',
    ],
  },
  {
    icon: 'fas fa-palette',
    title: 'Branding e Identidade de Marca',
    desc: 'Construímos percepção e diferenciação para sua marca ser lembrada e reconhecida.',
    items: [
      'Naming',
      'Logotipo e identidade visual',
      'Brandbook e manual de marca',
      'Tom de voz e storytelling',
      'Rebranding',
    ],
  },
  {
    icon: 'fab fa-instagram',
    title: 'Gestão de Redes Sociais',
    desc: 'A parte mais visível da sua marca, integrada à estratégia para gerar conexão real.',
    items: [
      'Planejamento de conteúdo',
      'Criação de posts (design + copy)',
      'Gestão de perfis (Instagram, LinkedIn, TikTok)',
      'Calendário editorial',
      'SAC 2.0 e interação',
      'Relatórios de performance',
    ],
  },
  {
    icon: 'fas fa-bullseye',
    title: 'Tráfego Pago',
    desc: 'Mídia de performance focada em resultado direto: leads e vendas previsíveis.',
    items: [
      'Meta Ads, Google Ads e TikTok Ads',
      'Remarketing',
      'Testes A/B',
      'Otimização de ROI (CAC, LTV)',
      'Funis de conversão',
    ],
  },
  {
    icon: 'fas fa-search',
    title: 'SEO',
    desc: 'Aquisição orgânica de longo prazo. Sua marca encontrada por quem realmente busca.',
    items: [
      'SEO on-page',
      'SEO técnico',
      'Link building',
      'Pesquisa de palavras-chave',
      'Conteúdo para blog',
    ],
  },
  {
    icon: 'fas fa-pen-nib',
    title: 'Conteúdo e Copywriting',
    desc: 'Texto que conecta e converte. Da headline ao roteiro, cada palavra com intenção.',
    items: [
      'Copy para anúncios',
      'Roteiros para vídeos',
      'Blog posts',
      'E-mail marketing',
      'Landing pages',
    ],
  },
  {
    icon: 'fas fa-code',
    title: 'Desenvolvimento Web',
    desc: 'Infraestrutura digital sólida. Sites e landing pages preparados para converter.',
    items: [
      'Sites institucionais',
      'Landing pages de alta conversão',
      'E-commerce',
      'UX/UI design',
      'Performance e velocidade',
    ],
  },
  {
    icon: 'fas fa-cogs',
    title: 'Automação e CRM',
    desc: 'Escala e previsibilidade. Marketing e vendas integrados em fluxos inteligentes.',
    items: [
      'Implementação de CRM (HubSpot, RD Station)',
      'Fluxos de automação de e-mail',
      'Nutrição de leads',
      'Lead scoring',
      'Integração marketing + vendas',
    ],
  },
  {
    icon: 'fas fa-video',
    title: 'Produção Audiovisual',
    desc: 'Hoje, vídeo e foto não são opcionais. São o motor do alcance e do engajamento.',
    items: [
      'Vídeos institucionais, reels e anúncios',
      'Fotografia profissional',
      'Motion design',
      'Edição de vídeo',
    ],
  },
  {
    icon: 'fas fa-chart-line',
    title: 'BI, Dados e Performance',
    desc: 'Decisão baseada em dado, não em achismo. Otimização contínua com clareza total.',
    items: [
      'Dashboards e relatórios',
      'Métricas (CAC, ROI, ROAS)',
      'Business Intelligence',
      'Otimização baseada em dados',
    ],
  },
  {
    icon: 'fas fa-bullhorn',
    title: 'Influenciadores e PR',
    desc: 'Construção de autoridade, alcance e reputação por meio de parcerias e mídia.',
    items: [
      'Gestão de influenciadores',
      'Parcerias estratégicas',
      'Assessoria de imprensa',
      'Gestão de reputação',
    ],
  },
  {
    icon: 'fas fa-rocket',
    title: 'Growth Marketing',
    desc: 'Mentalidade de crescimento acelerado. Testar, medir, escalar.',
    items: [
      'Growth hacking',
      'Experimentação de canais',
      'Otimização de funil completo',
      'Aquisição e retenção',
    ],
  },
];

function Services() {
  const swiperOptions = {
    modules: [Navigation],
    loop: true,
    spaceBetween: 30,
    slidesPerView: 3,
    breakpoints: {
      0: { slidesPerView: 1 },
      640: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
    navigation: {
      nextEl: '.services-nav-next',
      prevEl: '.services-nav-prev',
    },
  };

  return (
    <section id="services" className="services section-padding">
      <div className="container">
        <div className="sec-head mb-80">
          <div className="d-flex align-items-center">
            <div className="wow fadeInUp">
              <span className="sub-title main-color mb-5">Nossas Soluções</span>
              <h3 className="fw-600 text-u" style={{ fontSize: 'clamp(1.8rem, 4vw, 3.2rem)' }}>
                Marketing como{' '}
                <span className="fw-200">parte do crescimento.</span>
              </h3>
            </div>
          </div>
        </div>
        <div className="serv-swiper">
          <Swiper
            {...swiperOptions}
            id="content-carousel-container-unq-serv"
            className="swiper-container"
          >
            {services.map((service, i) => (
              <SwiperSlide key={i}>
                <div
                  className="item-box"
                  style={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                  }}
                >
                  <div
                    className="icon mb-30 main-color"
                    style={{ fontSize: '2.4rem' }}
                  >
                    <i className={service.icon}></i>
                  </div>
                  <h5 className="mb-15">{service.title}</h5>
                  <p style={{ marginBottom: '20px' }}>{service.desc}</p>
                  <ul
                    style={{
                      listStyle: 'none',
                      padding: 0,
                      margin: 0,
                      borderTop: '1px solid rgba(255,255,255,0.08)',
                      paddingTop: '20px',
                    }}
                  >
                    {service.items.map((it, j) => (
                      <li
                        key={j}
                        style={{
                          padding: '6px 0',
                          fontSize: '0.92rem',
                          opacity: 0.85,
                          display: 'flex',
                          alignItems: 'flex-start',
                        }}
                      >
                        <span
                          className="main-color"
                          style={{
                            marginRight: '10px',
                            fontSize: '0.7rem',
                            marginTop: '6px',
                          }}
                        >
                          ●
                        </span>
                        <span>{it}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <div
          className="d-flex justify-content-center align-items-center mt-50"
          style={{ gap: '14px' }}
        >
          <button
            type="button"
            className="services-nav services-nav-prev"
            aria-label="Anterior"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="19" y1="12" x2="5" y2="12"></line>
              <polyline points="12 19 5 12 12 5"></polyline>
            </svg>
          </button>
          <button
            type="button"
            className="services-nav services-nav-next"
            aria-label="Próximo"
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="5" y1="12" x2="19" y2="12"></line>
              <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
          </button>
        </div>

        <style>{`
          .services-nav {
            width: 52px;
            height: 52px;
            border-radius: 50%;
            border: 1px solid rgba(255, 255, 255, 0.18);
            background: transparent;
            color: #fff;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transition: all 0.3s ease;
            padding: 0;
          }
          .services-nav:hover {
            background: #F5C518;
            border-color: #F5C518;
            color: #000;
          }
          .services-nav.swiper-button-disabled {
            opacity: 0.3;
            cursor: not-allowed;
          }
        `}</style>

        <div
          className="services-cta mt-80 text-center wow fadeInUp"
          style={{
            padding: '60px 30px',
            border: '1px solid rgba(255,255,255,0.08)',
            borderRadius: '20px',
            background: 'rgba(255,255,255,0.02)',
          }}
        >
          <h3
            className="services-cta-headline mb-30"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.2rem)', lineHeight: 1.25 }}
          >
            Seu marketing precisa de{' '}
            <span className="main-color">direção</span>?
          </h3>
          <a
            href="https://wa.me/553198550500"
            target="_blank"
            rel="noreferrer"
            className="butn butn-md butn-bg main-colorbg radius-5"
            style={{ color: '#000' }}
          >
            <span className="text" style={{ color: '#000' }}>
              Agendar diagnóstico gratuito
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}

export default Services;
